import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, ShoppingBag, ArrowUpDown, BarChart3 } from "lucide-react";
import { IMAGES } from "../localConstants/images";
import { useBuyA1XModal } from "../contexts/BuyA1XModalContext";
import { useGetAccountInfo } from "../hooks/sdkDappHooks";

export const Sidebar = () => {
  const location = useLocation();
  const { openModal } = useBuyA1XModal();
  const { address } = useGetAccountInfo();

  const menuItems = [
    { path: "/", label: "Dashboard", icon: Home },
    { path: "/marketplace", label: "Marketplace", icon: ShoppingBag },
    { path: "/bridge", label: "Bridge", icon: ArrowUpDown },
    { path: "https://xexchange.com/staking/A1X-0d446d", label: "Staking", icon: BarChart3, external: true },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <aside className="fixed left-0 top-0 bottom-0 w-64 bg-neutral-900 border-r border-neutral-700 hidden lg:block">
      <div className="flex flex-col h-full">
        {/* Logo */}
        <div className="flex items-center gap-3 p-6 border-b border-neutral-700">
          <img src={IMAGES.AINEXUS} alt="AiNexus" className="h-8 w-auto" />
          <span className="text-white font-semibold text-lg">AiNexus</span>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 flex flex-col">
          <div className="space-y-2">
            {menuItems.map((item) => {
              const IconComponent = item.icon;
              if (item.external) {
                return (
                  <a
                    key={item.path}
                    href={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 text-neutral-300 hover:bg-neutral-800/60 hover:text-white"
                  >
                    <IconComponent size={20} />
                    <span className="font-medium">{item.label}</span>
                  </a>
                );
              }
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 ${
                    isActive(item.path)
                      ? "bg-green-500/15 text-green-400 border border-green-500/25"
                      : "text-neutral-300 hover:bg-neutral-800/60 hover:text-white"
                  }`}
                >
                  <IconComponent size={20} />
                  <span className="font-medium">{item.label}</span>
                </Link>
              );
            })}
          </div>

          {/* Buy A1X Card - Bottom aligned */}
          {address && (
            <div className="mt-auto mb-4">
              <div 
                className="relative rounded-xl overflow-hidden cursor-pointer hover:opacity-90 transition-opacity"
                onClick={openModal}
              >
                <img 
                  src="https://pulsarmoney.b-cdn.net/ainexus/buy-a1x.png"
                  alt="Buy A1X"
                  className="w-full h-auto rounded-xl"
                />
                {/* Text overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <p className="text-white font-normal text-left text-base">
                    Buy A1X
                  </p>
                </div>
              </div>
            </div>
          )}
        </nav>
      </div>
    </aside>
  );
};
